import './SpinnerStyles.css'

const Spinner = () => <div className="spinner"></div>

export default Spinner
